import {
  Companion_instance2x38zxm4t0kdk as Companion_instance,
  ExceptionMessage21t2b5aa8xtox as ExceptionMessage,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../lightningserver/LsErrorException.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installLsError(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.exceptions.Companion.invoke' call
  var tmp$ret$0 = new (installLsError$$inlined$invoke$1())(1.0);
  _this__u8e3s4.icw(tmp$ret$0);
}
var installLsError$$inlined$invoke$1Class;
function installLsError$$inlined$invoke$1() {
  if (installLsError$$inlined$invoke$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.rdr_1 = $priority;
      }
      g90() {
        return this.rdr_1;
      }
      bcw(view, exception) {
        if (!(exception instanceof LsErrorException()))
          return null;
        report(exception);
        // Inline function 'kotlin.takeUnless' call
        var this_0 = exception.wdr_1.q4b_1;
        var tmp;
        if (!isBlank(this_0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp1_subject = exception.vdr_1;
          tmp_0 = tmp1_subject === 400 ? 'Incorrectly formed information was sent.' : tmp1_subject === 401 ? "You're not authenticated properly." : tmp1_subject === 403 ? "You're not allowed to do this." : tmp1_subject === 500 ? "Something's wrong with the server." : 'Got a code ' + exception.vdr_1 + ' from the server.';
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return new (ExceptionMessage())('Error', tmp_0);
      }
    }
    initMetadataForClass($);
    installLsError$$inlined$invoke$1Class = $;
  }
  return installLsError$$inlined$invoke$1Class;
}
//region block: exports
export {
  installLsError as installLsError350ro3euqscko,
};
//endregion

//# sourceMappingURL=LsErrorHandlers.mjs.map
